module.exports = __webpack_public_path__ + "media/newstyle/images/icon-trash-c9ae45cef44de3113e2f108be75fbe0e.svg";